import { useState, useEffect } from 'react';

// Tracks whether the viewport is at or below `breakpoint` px, updating on resize.
// Use this instead of a one-off `window.innerWidth` check so table columns, layouts,
// etc. stay responsive to live window resizing rather than only the initial render.
const useIsMobile = (breakpoint = 768) => {
    const [isMobile, setIsMobile] = useState(
        typeof window !== 'undefined' ? window.innerWidth <= breakpoint : false
    );

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= breakpoint);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [breakpoint]);

    return isMobile;
};

export default useIsMobile;
